import { render, staticRenderFns } from "./ReportItem.vue?vue&type=template&id=8a995634&scoped=true&"
import script from "./ReportItem.vue?vue&type=script&lang=js&"
export * from "./ReportItem.vue?vue&type=script&lang=js&"
import style0 from "./ReportItem.vue?vue&type=style&index=0&id=8a995634&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a995634",
  null
  
)

export default component.exports